export default "__VITE_ASSET__BnNGQqcV__"